import React, { useRef, useEffect } from "react";

import {Fancybox as NativeFancybox} from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

function Fancybox(props) {
  const container = useRef(null);
  const delegate = useRef(
      props.delegate || "[data-fancybox]"
  );
  const options = useRef(props.options || {});

  useEffect(() => {
    const containerElement = container.current;

    NativeFancybox.bind(
        containerElement,
        delegate.current,
        options.current
    );

    return () => {
      NativeFancybox.unbind(containerElement);
      NativeFancybox.close();
    };
  }, []);

  return <div ref={container}>{props.children}</div>;
}

export default Fancybox;
